export const TAB_SALES_DOCUMENTS = {
	NOT_PAID: 'not-paid',
	ALL: 'all',
	GENERATED: 'generated',
	CONFIRMED: 'confirmed',
	BOOKED: 'booked',
};

export const STATUS_SALES_DOCUMENTS = {
	GENERATED: 1,
	IN_SETTLEMENT: 2,
	REALIZED: 3,
	BOOKED: 4,
};

export const TYPES_SALES_DOCUMENTS = {
	FF: 1,
	NOTE: 2,
	FX: 3,
};

export const TYPES_SALES_TYPE_DOCUMENTS = {
	DOMESTIC: 1,
	UNION: 2,
	EXPORT: 3,
};

export const TYPES_SALES_EXPORT_TYPE = {
	COMARCH_ERP_OPTIMA: 1
};